import { useContext, memo } from 'react';

import { useLanguage } from '@languages/index';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import GUIDELINE_RULES from 'constants/guidelineRules';
import CampaignFormFieldGroup from '../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import { CampaignFormStepTwoContext } from '../../../../campaignFormStepTwo.context';

const PROHIBITIONS_BEAUTY_ORDER = {
  [GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_BEAUTY_OPTIONS.GRWM_AND_OTHER_PRODUCTS]: 1,
  [GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_BEAUTY_OPTIONS.MAKE_UP]: 2,
  [GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_BEAUTY_OPTIONS.TPO_MISMATCH]: 3,
  [GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_BEAUTY_OPTIONS.FINGERPRINTS]: 4,
  [GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_BEAUTY_OPTIONS.ENLARGE]: 5,
  [GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_BEAUTY_OPTIONS.SLIDESHOW]: 6,
  [GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_BEAUTY_OPTIONS.COMMERCIAL_CONTENTS]: 7,
  [GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_BEAUTY_OPTIONS.HDR]: 8,
  [GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_BEAUTY_OPTIONS.DEADZONE]: 9,
};

const ProhibitionBeautyFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };
  const { baseGuidelineRules } = useContext(CampaignFormStepTwoContext);

  return (
    <CampaignFormFieldGroup
      label={`1. ${languageTexts.create_reels_form_prohibition_beauty_title}`}
      description={languageTexts.create_reels_form_prohibition_beauty_desc}
      bordered
    >
      <div className="flex flex-col gap-4">
        {baseGuidelineRules
          ?.filter(
            (rule) =>
              rule.type === GUIDELINE_RULE_DTO_ENUMS.TYPE.PROHIBITION_BEAUTY,
          )
          ?.sort(
            (a, b) =>
              PROHIBITIONS_BEAUTY_ORDER[a.value] -
              PROHIBITIONS_BEAUTY_ORDER[b.value],
          )
          ?.map((rule) => {
            return (
              <div key={rule.id} className="flex items-start gap-2">
                <p className="text-[15px]">
                  {`·  ${GUIDELINE_RULES.GetOptionTranslationMap(
                    rule.groupName,
                    rule.value as string,
                  )}`}
                </p>
              </div>
            );
          })}
      </div>
    </CampaignFormFieldGroup>
  );
};

export default memo(ProhibitionBeautyFieldGroup);
